import { all } from "redux-saga/effects";
import { quanLyHocPhanSaga } from "./quanLyHocPhanSaga";

export default function* quyetDinhSagaWrapper() {
  yield all([quanLyHocPhanSaga()]);
}
